import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, MarkerF, InfoWindow, TrafficLayerF } from '@react-google-maps/api';
import './marker.css'
import { useHistory } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import BuoyIcon from '@mui/icons-material/Houseboat';

const MapContainer = ({ array, buoys }) => {

  const history = useHistory();
  const [ selected, setSelected ] = useState({});
  const [ buoySelected, setBuoySelected ] = useState({});
  const [ currentPosition, setCurrentPosition ] = useState({});

  const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY

  const defaultCenter = {
    lat: 33.3851, lng: -117.1734
  }

   const onSelect = item => {
    setSelected(item);
  }

  const onBuoySelect = item => {
    setBuoySelected(item);
  }

  const success = (position) => {
    const latitude  = parseFloat(position.coords.latitude);
    const longitude = parseFloat(position.coords.longitude);
    const currentPosition = {
      lat: latitude,
      lng: longitude
    }
    setCurrentPosition(currentPosition);
  }

  const ShowBuoyStations = () => {
    history.push('/map-buoys/true');
  }

  const BuoyButtonStyle = {
    // Set CSS for the control.
    backgroundColor : "#fff",
    border : "2px solid #fff",
    borderRadius : "3px",
    boxShadow : "0 2px 6px rgba(0,0,0,.3)",
    color : "rgb(25,25,25)",
    cursor : "pointer",
    fontFamily : "Roboto,Arial,sans-serif",
    fontSize : "12px",
    lineHeight : "37px",
    margin : "8px 0 22px",
    padding : "0 0px",
    textAlign : "center",
    type : "button",
    width: "40px",
    height: "39px",
    position: "absolute",
    top:45,
    right:11,
  }


  const footer = (
    <div >
      <div >
         <IconButton style={BuoyButtonStyle} aria-label="See buoy stations" onClick={() => ShowBuoyStations()}>
          <BuoyIcon />
        </IconButton>
      </div>
    </div>
  );

  const mapStyles = () => {
      return {
        marginTop: "-20px",
        height: "85dvh",
        width: "100%"
      }
  }

  
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(success);
  })

  const createMapOptions =  {
    gestureHandling: 'greedy',
  }

  const routeChange = (spotId) =>{ 
    let path = `spotdetail/`+spotId; 

    history.push(path);
  }
     return (
    <>
      <LoadScript
        id="script-loader-6"
        googleMapsApiKey={API_KEY}
      >
        <GoogleMap
          id='example-map-6'
          mapContainerStyle={mapStyles()}
          //draggable={true}
          gestureHandling="greedy"
          zoomControl={true}
          zoom={10}
          center={currentPosition ? currentPosition : defaultCenter}
          options={createMapOptions}
        >
          <TrafficLayerF autoUpdate />
          {
         footer
      }
          <MarkerF
            key="0"
            position={currentPosition}
            icon={"http://maps.google.com/mapfiles/ms/icons/blue.png"}
             />
          
          {
            array ?
            array.map(item => {

              var myLatLng = { lat: item.location[0].lat, lng: item.location[0].lng};
              return (
              <MarkerF
              key={item.spotId}
              position={myLatLng}
              onClick={() => onSelect(item)}
              />
              )
            }) : null
          }

          {
            buoys ?
            buoys.map(item => {

              var myLatLng = { lat: item.lat, lng: item.lon};
              //var customLabel = {text: item.id, color: "blue"}
              return (
              <MarkerF
              key={item.id}
              position={myLatLng}
              onClick={() => onBuoySelect(item)}
              label= {"Station\n"+ item.name.substring(0,15) + "..."}
              //icon={"http://maps.google.com/mapfiles/ms/icons/red.png"}
              icon={"http://maps.google.com/mapfiles/kml/pal3/icon53.png"}
              />
              )
            }) : null
          }
      
          {
            selected.location ?
            (
              //var myLatLng = { lat: item.location[0].lat, lng: item.location[0].lng};
              <InfoWindow
              position={{lat: selected.location[0].lat, lng: selected.location[0].lng}}
              onCloseClick={() => setSelected({})}
            >
              <div >
                  <div style={{ fontSize: 18 }} onClick={() => routeChange(selected.spotId)}><a href=''>{selected.spotName}</a></div>
                  <div style={{ color: "grey" }}> Wave Height : {selected.waveHeight} ft </div>
                  <div style={{ color: "grey" }}> Water Temp : {selected.waterTemp} °f</div>
              </div>
            </InfoWindow>
            ) : null
          }

          {
            buoySelected.name ?
            (
              //var myLatLng = { lat: item.location[0].lat, lng: item.location[0].lng};
              <InfoWindow
              position={{lat: buoySelected.lat, lng: buoySelected.lon}}
              onCloseClick={() => setBuoySelected({})}
            >
              <div >
                  <div style={{ fontSize: 18 }}><a href=''>{buoySelected.name}</a></div> 
              </div>
            </InfoWindow>
            ) : null
          }
        </GoogleMap>
      </LoadScript>
    </>
     )
  }

export default MapContainer;